export const SALES_ORDER_STATUS_MAP = {
  1: "Draft",
  2: "Released",
  3: "In Progress",
  4: "Completed",
  5: "On Hold",
  6: "Cancelled",
};
